<script lang="tsx">
import { defineComponent } from 'vue'
const [name] = createNamespace('CommonTagInput')
import { Select } from 'ant-design-vue'
import { createNamespace } from '@bd/vue3-utils'
export default defineComponent({
  name,
  inheritAttrs: false,
  setup(_, { attrs }) {
    return () => <Select allow-clear token-separators={[',']} mode='tags' dropdown-style={{ display: 'none' }} {...attrs} />
  }
})
</script>
